import { render, staticRenderFns } from "./startClassRecord.vue?vue&type=template&id=7d9f1a59"
import script from "./startClassRecord.vue?vue&type=script&lang=js"
export * from "./startClassRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports